import { Model } from "@interfaces/model.interface";
import { PaymentTermsType } from "@enums/paymentTerms.enum";

export interface PaymentTerm extends Model {
	termCode: string;
	termDay?: number;
	termType: PaymentTermsType;
}

export class PaymentTerm implements PaymentTerm {
	constructor(data?: Partial<PaymentTerm>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}